<template>
  <b-navbar type="dark" variant="dark" sticky="false" toggleable="sm" >
    <div class="container">
    <b-navbar-brand to="/">雪谋</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav >
      <b-navbar-nav class="nav-item-title-align" >
        <!-- <b-nav-item herf="#">文章</b-nav-item>
        <b-nav-item to="/sogou-skin">搜狗输入法皮肤</b-nav-item>
        <b-nav-item to="/wechat-sticker">微信表情</b-nav-item>
        <b-nav-item to="/wechat-game">微信小游戏</b-nav-item> -->
        <b-nav-item to="/war-map">魔兽地图</b-nav-item>
        <b-nav-item to="/sc-map">星际地图</b-nav-item>
        <b-nav-item to="/mi-theme">小米主题</b-nav-item>
        <b-nav-item to="/about">关于</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
  export default {
    props: ['nav-sticky'],
  }
</script>

<style lang="stylus" scoped>
  .nav-item-title-align{
    text-align: center;
  }
</style>
